/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/top.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Collects the top values for a field. Includes repeated values.',
  examples: [
    'FROM employees\n| STATS top_salaries = TOP(salary, 3, "desc"), top_salary = MAX(salary)',
  ],
  params: {
    field: 'The field to collect the top values for.',
    limit: 'The maximum number of values to collect.',
    order: 'The order to calculate the top values. Either `asc` or `desc`, and defaults to `asc` if omitted.',
    outputField: 'The extra field that, if present, will be the output of the TOP call instead of `field`.',
  },
};

export default docs;
